export const tokenService = {
  get: (): string | null => localStorage.getItem("admin_token"),

  set: (token: string) => {
    localStorage.setItem("admin_token", token);
  },

  clear: () => {
    localStorage.removeItem("admin_token");
  },
};
